export default {
    apiPath: process.env.REACT_APP_API_URL,
    apiPathV2: process.env.REACT_APP_API_URL_V2
}


//apiPath: 'http://34.207.244.68/services/api/'
//'http://am.bioped.com/services/api/'
//https://bioped-dev.kpd-i.com/services/api/



// WEBPACK FOOTER //
// ./src/config.js